<sim-basic-material-dialog
	(closeClicked)="close({action: 'ok'})"
	[finished]="finishedLoading"
	[headerIcon]="{fontIcon: 'fa-cog', fontSet: 'fad'}"
	[headerText]="T.DYNAMIC_AUDIO_CHANNEL_POPUP_HEADER | translate"
	[matDialogData]="data"
	[rect]="rect"
	[showClosingX]="true"
>
	<ng-container dialogContent>
		<div cdkDropListGroup class="dialogBody">
			<!--GROUPS COLUMN-->
			<section id="channelGroups">
				<h2>{{ T.DYNAMIC_AUDIO_CHANNEL_POPUP_CHANNEL_GROUPS_LABEL | translate }}</h2>
				<div class="scrollContainer">
					<!--NO GROUPS MSG-->
					@if (!groupMap.size) {
						<div class="noChannelGroups">
							<i class="fad fa-volume-up fa-3x"></i>
							{{ T.DYNAMIC_AUDIO_CHANNEL_POPUP_NO_GROUPS_ASSIGNED | translate }}
						</div>
					}

					<!--GROUP-->
					@for (channelGroup of orderedGroups(); track TrackByMethods.trackById(i, channelGroup); let i = $index) {
						@if (i !== 0) {
							<mat-divider class="channelGroupDivider" />
						}
						<div [class.inactive]="!groupMap.get(channelGroup).isActive" class="channelGroup">
							<!--GROUP HEADER-->
							<div *ngVar="channelGroup.id === editGroupId() as isCurrentlyEdited" class="channelGroupHeader">
								<i class="channelIcon groupIcon fad fa-layer-group"></i>
								@if (!isCurrentlyEdited) {
									<span>
										{{ channelGroup.name }}
									</span>
								} @else {
									<mat-form-field subscriptSizing="dynamic">
										<mat-label>{{ T.DYNAMIC_AUDIO_CHANNEL_GROUP_NAME | translate }}</mat-label>
										<input [formControl]="groupNameFormCtrl" matInput placeholder="{{ channelGroup.name }}" />
									</mat-form-field>
								}
								<!--GROUP HEADER ACTIONS-->
								<span class="channelGroupActions">
									<mat-slide-toggle
										(change)="toggleGroupActive(channelGroup, $event)"
										*ngVar="groupMap.get(channelGroup).isActive as isActive"
										[checked]="isActive"
										[hideIcon]="true"
										[matTooltip]="(isActive ? T.TOGGLE_INACTIVE : T.TOGGLE_ACTIVE) | translate"
										class="activityStatusToggle"
									/>
									@if (!isCurrentlyEdited) {
										<button
											(click)="editChannelGroupName(channelGroup)"
											[disabled]="editGroupId() !== null"
											[matTooltip]="T.BUTTON_ITEM_EDIT | translate: {item: T.LABEL_NAME | translate}"
											mat-icon-button
										>
											<mat-icon fontIcon="fa-edit" fontSet="fad" />
										</button>
									} @else {
										<button
											(click)="updateGroupName(channelGroup)"
											[matTooltip]="T.BUTTON_ITEM_SAVE | translate: {item: T.LABEL_NAME | translate}"
											mat-icon-button
										>
											<mat-icon fontIcon="fa-check" fontSet="fad" />
										</button>
									}
									<button
										(click)="updateGroupOrder(channelGroup, 'up')"
										[disabled]="i === 0"
										[matTooltip]="T.BUTTON_ITEM_MOVE_UP | translate: {item: T.LABEL_ORDER | translate}"
										mat-icon-button
									>
										<mat-icon fontIcon="fa-arrow-up" fontSet="fad" />
									</button>
									<button
										(click)="updateGroupOrder(channelGroup, 'down')"
										[disabled]="i === groupMap.size - 1"
										[matTooltip]="T.BUTTON_ITEM_MOVE_DOWN | translate: {item: T.LABEL_ORDER | translate}"
										mat-icon-button
									>
										<mat-icon fontIcon="fa-arrow-down" fontSet="fad" />
									</button>
								</span>
							</div>
							<!--GROUP DROP-LIST-->
							<div
								(cdkDropListDropped)="channelDroppedAssigned($event, channelGroup)"
								*ngVar="groupMap.get(channelGroup) as channelGroupInfo"
								cdkDropList
								class="dropList"
							>
								@if (!channelGroupInfo.channels.size) {
									<div class="noAssignedChannels">
										{{ T.DYNAMIC_AUDIO_CHANNEL_POPUP_NO_ASSIGNED_CHANNELS | translate }}
									</div>
								}
								@for (assignedChannel of channelGroupInfo.channels; track assignedChannel; let i = $index) {
									<span
										[cdkDragData]="{
											channel: assignedChannel,
											index: i,
											previousGroup: channelGroup,
										}"
										cdkDrag
										class="inputChannelCard"
									>
										<ng-container *ngTemplateOutlet="channelItem; context: {$implicit: assignedChannel}" />
									</span>
								}
							</div>
						</div>
					}
				</div>
			</section>

			<mat-divider vertical />

			<!--AVAILABLE COLUMN-->
			<section>
				<h2>{{ T.DYNAMIC_AUDIO_CHANNEL_POPUP_AVAILABLE_MICS_LABEL | translate }}</h2>
				<div
					(cdkDropListDropped)="channelDroppedUnassigned($event)"
					[cdkDropListSortingDisabled]="true"
					[id]="AVAILABLE_DROP_LIST_ID"
					cdkDropList
					class="availableChannelsContainer scrollContainer"
				>
					@if (unassignedChannels.size === 0) {
						<div class="availableChannelsPlaceholder">
							<mat-label [innerHTML]="T.DYNAMIC_AUDIO_CHANNEL_POPUP_NO_UNASSIGNED_CHANNELS | translate" />
						</div>
					}
					@for (inputChannel of unassignedChannels; track TrackByMethods.trackById(i, inputChannel); let i = $index) {
						<span
							[cdkDragData]="{
								channel: inputChannel,
								index: i,
								previousGroup: null,
							}"
							cdkDrag
							class="inputChannelCard"
						>
							<ng-container *ngTemplateOutlet="channelItem; context: {$implicit: inputChannel}" />
						</span>
					}
				</div>
			</section>
		</div>
	</ng-container>

	<ng-container actions>
		@if (hasUnsavedChanges) {
			<div class="unsavedChangesWarning">
				<mat-icon color="warn" fontIcon="fa-exclamation-triangle" fontSet="fad" inline />
				<label>
					{{ T.DYNAMIC_AUDIO_CHANNEL_POPUP_UNSAVED_CHANGES | translate }}
				</label>
			</div>
		}
		<sim-button
			(onClick)="saveCurrentAsDefault()"
			[disabled]="false"
			[icon]="{fontSet: 'fa', fontIcon: 'fa-cube'}"
			[label]="T.DYNAMIC_AUDIO_CHANNEL_POPUP_SET_DEFAULT"
			color="accent"
		/>
		<sim-button
			(onClick)="revertToDefault()"
			[disabled]="!(recorderMapping?.defaultDynamicInputGroupPresetId !== null)"
			[icon]="{fontSet: 'fa', fontIcon: 'fa-redo'}"
			[label]="T.DYNAMIC_AUDIO_CHANNEL_POPUP_REVERT_DEFAULT"
			color="accent"
		/>
		<sim-button
			(onClick)="doSave()"
			[disabled]="!hasUnsavedChanges"
			[icon]="{fontSet: 'fa', fontIcon: 'fa-check'}"
			[label]="T.DYNAMIC_AUDIO_CHANNEL_POPUP_APPLY_CHANNELS"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>

<!--CHANNEL TEMPLATE-->
<ng-template #channelItem let-inputChannel>
	<mat-icon [fontIcon]="getChannelFontIcon(inputChannel)" class="channelIcon" fontSet="fad" />
	{{ inputChannel.displayName }}
	<mat-icon class="dragIndicator" fontIcon="fa-arrows" fontSet="fad" matTooltip="{{ T.DRAG_AND_DROP | translate }}" />
</ng-template>
